import type maplibregl from "maplibre-gl";
import type { LayerStyleFill } from "@designboticteam/map";
import { buildStateExpression } from "../expressionBuilders/buildStateExpression";

type Props = {
	sourceId: string;
	idleFill: LayerStyleFill;
	matchedFill?: LayerStyleFill;
	hoverFill?: LayerStyleFill;
};

function createStyleFillPaint({ sourceId, idleFill, matchedFill, hoverFill }: Props): maplibregl.FillLayerSpecification["paint"] {
	return {
		"fill-color": buildStateExpression({
			literal: { idle: idleFill.color, matched: matchedFill?.color, hover: hoverFill?.color ?? idleFill.color },
		}),
		"fill-opacity": buildStateExpression({
			globalStateModifierKey: `opacity__${sourceId}`,
			literal: { idle: idleFill.opacity ?? 1, matched: matchedFill?.opacity, hover: hoverFill?.opacity ?? 1 },
		}),
	};
}

function createStyleFillLayer({
	sourceId,
	sourceLayerId,
	idleFill,
	matchedFill,
	hoverFill,
	isVisible,
}: Props & {
	sourceLayerId: string;
	isVisible: boolean;
}): maplibregl.AddLayerObject {
	return {
		id: `${sourceId}__fill`,
		source: sourceId,
		"source-layer": sourceLayerId,
		type: "fill",
		paint: createStyleFillPaint({ sourceId, idleFill, matchedFill, hoverFill }),
		layout: { visibility: isVisible ? "visible" : "none" },
	};
}

export { createStyleFillLayer, createStyleFillPaint };
